export enum SYSTEM_CLAIM_TYPES {
  PAGE_ACCESS = "Application:FactManager:Page",
  PERMISSION = "Permissions",
}

export function getClaim(claimType: string, claimValue: string) {
  return `${claimType}:${claimValue}`;
}
